import React, { useState } from 'react';
import { AiOutlineSave } from 'react-icons/ai';
import { Button } from '../design-system';

interface SaveButtonProps {
  onClick?: (...args: any[]) => any;
  fontSize?: number;
  noLoading?: boolean;
  [key: string]: any;
}

const SaveButton = ({
  onClick,
  fontSize,
  noLoading,
  ...props
}: SaveButtonProps) => {
  const [loading, setLoading] = useState(false);
  const handleSaving = async () => {
    if (!noLoading) setLoading(true);
    try {
      if (onClick) await onClick();
    } finally {
      if (!noLoading) setLoading(false);
    }
  };

  return (
    <Button
      title="Save"
      type="button"
      aria-label="Save Item"
      variant="greyText"
      loading={loading}
      {...props}
      onClick={handleSaving}
    >
      <AiOutlineSave color="green" fontSize={fontSize || 20} />
    </Button>
  );
};

export default SaveButton;
